
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import NodeInstance from "../../Global/nodeAxios";

const getVisasummaryData = createAsyncThunk("api/details", async ({ page, limit, search } = {}) => {
  try {
    const params = new URLSearchParams();
    if (page !== undefined && page !== null) params.append("page", page);
    if (limit !== undefined && limit !== null) params.append("limit", limit);
    if (search && typeof search === "string" && search.trim()) params.append("search", search.trim());
    const query = params.toString() ? `?${params.toString()}` : "";
    const response = await NodeInstance.get(`/dashboard/visa-stock/details${query}`);
    return response.data;
  } catch (e) {
    throw new Error(e.message);
  }
});

const visaSummarDataSlice = createSlice({
  name: "details",
  initialState: {
    data: null,
    pagination: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVisasummaryData.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.pagination = action.payload.pagination || null;
        state.isLoading = false;
        state.status = true;
      })
      .addCase(getVisasummaryData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getVisasummaryData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getVisasummaryData };
export default visaSummarDataSlice.reducer;
